<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover; color: #fff" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 15%">
                            <h1 class="custom-title-header text-center">
                                <strong class="mt-4"> Crafting Magic through <br />
                                                Skill and Service</strong>
                            </h1>
                            <h3 class="mt-3 mb-4 text-white custom-header-subtitle-sub text-center poppin-font">
                                Welcome to Genie Workers, where we believe in the magic of connecting people with reliable <br />
                                and skilled service providers. Our platform is designed to simplify your life by offering a <br />
                                seamless experience in finding and booking a wide range of services.<br />
                                Here's a glimpse into the world of Genie Workers</h3>
                            <br>
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-white">
    
            <CCol sm="12" style="width: 90%; background-size: cover; margin: auto; color: #fff; position: relative; z-index: 1;">
                <CRow class="mb-5">
                    <CCol sm="6">
                        <h1 class="header-title-genie text-black poppin-font text-48px mt-5">
                            Our Story
                        </h1>
                        <h3 class="mt-3 mb-4 custom-text-story text-left text-black">
                            Born from the belief that every skilled professional deserves a platform to showcase their expertise, Genie Workers emerged as a response to the need for a reliable and empowering space.
                        </h3>
                    </CCol>
                    <CCol sm="6">
                        <br /><br /><br />
                        <h3 class="mt-3 mb-4 custom-text-story text-left text-black mt-5">
                            Our journey began with a vision to connect talented individuals with users seeking top-tier services, creating a harmonious ecosystem where skills flourish, and wishes are fulfilled.
                        </h3>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="12">
                        <img style="max-width:100%;z-index:1" src="../assets/img/video.png" />
                    </CCol>
                </CRow>
            </CCol>
    
        </CCol>
    
        <CCol sm="12" class="bg-main-blue" style="margin-top: -200px;">
            <br /> <br /> <br /> <br /><br /> 
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;color: #fff">
                <br /><br /> <br /> <br /> <br /><br /> 
                <CRow class="mt-3">
                    <CCol sm="4">
                        <img style="max-width:100%" src="../assets/img/bos.png" />
                    </CCol>
                    <CCol sm="8">
                        <h3 class="poppin-font custom-speech-bos ml-3 mt-3"><b>We Believe Innovation is The Key to Build a Better Future for Our People.</b></h3>
                        <h3 class="mt-3 mb-4 custom-speech-sub-bos text-left text-white ml-3">
                            In the genesis of Genie Workers, our vision was clear: to create a space where skilled professionals can thrive, where their expertise is not just recognized but elevated. Our journey started with a belief that every individual, regardless of experience,
                            deserves a platform to showcase their skills and connect with those seeking top-tier services.</h3>
                        <img src="../assets/img/Sign.png" style="max-width:100%" class="ml-3" />
                        <br />
                        <h4 class="ml-3 mt-2">Rasid</h4>
                        <h5 class="ml-3 mt-2 mb-5">Founder and CEO Genie Workers</h5>
                    </CCol>
                </CRow>
            </CCol>
            <br /> <br /> 
        </CCol>
    
        <CCol sm="12" class="bg-white">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;color: #fff">
                <CRow>
                    <CCol sm="6">
                        <h1 class="custom-text-40px text-black poppin-font mt-5">
                            Our Mission
                        </h1>
                        
                        <label class="custom-header-subtitle-sub text-left text-black-dark mt-4">At Genie Workers, our mission is to create a space where skilled professionals can thrive and users can confidently find the right genie for their service needs. 
                            We believe in the power of craftsmanship, expertise, and delivering exceptional service to our users.</label>
                       <br />   <br />
                            <img src="../assets/img/geniegroup.png" style="max-width:100%" class="mt-5"/>
                    </CCol>
                    <CCol sm="6">
                        <img src="../assets/img/Maskgroup.png" style="max-width:100%" class="mt-5"/>
                        <h1 class="header-title-genie text-black poppin-font text-48px mt-5">
                            Our Vision
                        </h1>
                        <label class="custom-header-subtitle-sub text-left text-black-dark mt-1">At Genie Workers, our vision is to craft a world where skilled professionals are empowered to showcase their expertise, connect with users seeking reliable services, and contribute to the creation of magical and thriving communities. 
                            We envision a platform where craftsmanship, skill, and dedication converge to make every service experience extraordinary.</label>
                        
                    </CCol>
                </CRow>
            </CCol>
        </CCol>

        <CCol sm="12" style="background-size: cover; color: #fff" :style="{ backgroundImage: `url(${backgroundMap})` }">
      
                <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;color: #fff">
                    <h1 class="header-title-genie text-black poppin-font text-48px mt-5 text-center mb-3">
                        Meet our amazing team
                        </h1>
                        <br /><br />
                    <CRow class="text-center">
                        <CCol sm="3"></CCol>
                        <CCol sm="3">
                            <img style="max-width:100%" src="../assets/img/sayed.png" class="text-right"/>
                        <br />
                        <h5 class="text-center text-24px text-black mt-2 custom-text-aladdin-sub">Dr. Sayed Irfan</h5>
                        <h6 class="text-center text-black mb-2 custom-header-subtitle-sub">CTO & Co founder</h6>
                        </CCol>
                        <CCol sm="3"> <img style="max-width:100%" src="../assets/img/faris.png" />
                            <h5 class="text-center text-24px text-black mt-2 custom-text-aladdin-sub">Faris</h5>
                        <h6 class="text-center text-black mb-2 custom-header-subtitle-sub">AI Developer</h6></CCol>
                        <CCol sm="3"></CCol>
                        <CCol sm="3"><img style="max-width:100%" src="../assets/img/nadia.png" />
                            <h5 class="text-center text-24px text-black mt-2 custom-text-aladdin-sub">Nadia</h5>
                        <h6 class="text-center text-black mb-2 custom-header-subtitle-sub">Back End Programmer</h6></CCol>
                        <CCol sm="3"><img style="max-width:100%" src="../assets/img/nurul.png" />
                            <h5 class="text-center text-24px text-black mt-2 custom-text-aladdin-sub">Nurul</h5>
                        <h6 class="text-center text-black mb-2 custom-header-subtitle-sub">Front End Developer</h6></CCol>
                        <CCol sm="3"><img style="max-width:100%" src="../assets/img/tita.png" />
                            <h5 class="text-center text-24px text-black mt-2 custom-text-aladdin-sub">Siti Tirta Dinar</h5>
                        <h6 class="text-center text-black mb-2 custom-header-subtitle-sub">Product Designer</h6></CCol>
                        <CCol sm="3"><img style="max-width:100%" src="../assets/img/ira.png" />
                            <h5 class="text-center text-24px text-black mt-2 custom-text-aladdin-sub">Shahira</h5>
                        <h6 class="text-center text-black mb-2 custom-header-subtitle-sub">Customer Experience Manager</h6></CCol>
                    </CRow>
                    </CCol>

        </CCol>

        <CCol sm="12">
            <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                <CRow class="mt-5">
                    <CCol sm="6">
                        <h1 class="custom-header-title text-left text-black text-48px mt-5">
                                <strong> Join Our Team</strong>
                            </h1>
                    </CCol>
                    <CCol sm="6">
                        <label class="custom-18px text-black-dark mt-4 text-left">Genie Workers family, where skilled professionals like you are invited to join our community of magic makers. 
                        If you're passionate about your craft and dedicated to delivering exceptional services, we want you on our team.
                    </label> 
                        

                                    <div class="text-left mb-5 mt-5">
                                            <span class="button-Explore-dark-position">
                        <b class="ml-3 mr-3">See Open Positions</b>  
                    </span>
                    </div>
                      
                    </CCol>
                    
                </CRow>
            </CCol>
        </CCol>

        <CCol sm="12" class="p-1" style="background-size: cover;border-top-right-radius: 20px;border-top-left-radius: 20px; color: #fff" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 90%;margin: auto;">
                        <div class="text-center">
                            <h1 class="header-title-genie text-white poppin-font text-48px mt-5">Join the Genie Worker Community</h1>
                            <br />
                            <label class="custom-header-subtitle text-white">
                                Ready to experience a new level of convenience and efficiency? Join the growing <br />
                                Genie Workers community and let us take care of your service needs. 
                                Say goodbye to the hassle<br />
                                 of finding reliable providers – your genie is just a click away.
                            </label>
                            <br />
                            <br />  <br />
                            <br />

                            <CButton class="button-Explore"><span class="ml-2 mr-2">Register Now</span></CButton>
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap

        };
    },
    created() {
        AOS.init();
    },

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>